import styled from 'styled-components'

export const IntroTitle = styled.h2`
  font-size: 24px;
  font-weight: 400;
  line-height: 1.4;
  margin-bottom: 32px;

  a,
  em {
    text-decoration: none;
    font-style: normal;
    font-weight: 500;
    color: ${({ theme }) => theme.brand.jungle};
  }

  @media (min-width: 768px) {
    font-size: 32px;
    margin-bottom: 40px;
  }
`
